import config from '../../config';
import Pusher from 'pusher-js';

export default new Pusher(config.pusher_key, {
    cluster: 'eu',
    forceTLS: true
});
